import { computed, defineComponent } from 'vue';
import { usePayoutOrderListStore } from '@/store/payout-order/payout-order-list.store';
import { storeToRefs } from 'pinia';
import { Refresh } from '@element-plus/icons-vue';
import { ComponentSize } from '@/models/common/component-size.model';
import { usePayoutOrderListFilter } from '@/hooks/payout-order/payout-order-list-filter.composables';
import { usePayoutOrderList } from '@/hooks/payout-order/payout-order-list.composables';
import { useAdminTakenPayoutOrderCount } from '@/hooks/payout-order/payout-order-count.composables';
import { AdminTakenTag } from '@/models/common/admin-taken-tag.model';

const icons = {
  Refresh,
};

export default defineComponent({
  name: 'PayoutOrderListHeader',
  setup() {
    const { submitAndValidateForm } = usePayoutOrderListFilter();
    const { loadPayoutOrderList } = usePayoutOrderList();

    const payoutOrderListStore = usePayoutOrderListStore();
    const { isPayoutOrderListLoading } = storeToRefs(payoutOrderListStore);

    const { adminTakenPayoutOrderCount } = useAdminTakenPayoutOrderCount();

    const search = async (): Promise<void> => {
      if (!(await submitAndValidateForm())) {
        return;
      }

      await loadPayoutOrderList();
    };

    const isPayoutOrderTakenByAdmin = computed<boolean>(
      () => adminTakenPayoutOrderCount.value > 0,
    );

    const adminTakenPayoutOrderCountTag = computed<AdminTakenTag>(() => ({
      type: isPayoutOrderTakenByAdmin.value ? 'warning' : 'info',
      effect: isPayoutOrderTakenByAdmin.value ? 'dark' : 'plain',
      text: isPayoutOrderTakenByAdmin.value
        ? `You have ${adminTakenPayoutOrderCount.value} taken orders in current list`
        : 'No taken orders in current list',
    }));

    return {
      icons,
      isPayoutOrderListLoading,
      ComponentSize,
      search,
      adminTakenPayoutOrderCountTag,
    };
  },
});
